// floating-whatsapp.js
document.addEventListener('DOMContentLoaded', function() {
  // Create the floating WhatsApp icon
  const waBtn = document.createElement('div');
  waBtn.id = 'floating-whatsapp';
  waBtn.innerHTML = `<i class="fab fa-whatsapp" aria-hidden="true"></i>`;
  document.body.appendChild(waBtn);

  // WhatsApp click behavior
  const phoneNumber = '0555592086';
  const message = encodeURIComponent('שלום, הגעתי מדף: ' + document.title);
  
  waBtn.addEventListener('click', function() {
    const phoneFormatted = phoneNumber.startsWith('0') ? phoneNumber.substring(1) : phoneNumber;
    window.open('https://wa.me/972' + phoneFormatted + '?text=' + message, '_blank');
  });
});
